
// Price is no longer hardcoded here - each tier only carries the benefit
// `id` the bucket-model API needs to look up its live price. See
// useBucketPricing (fetches + caches price per benefit id) and
// buildCustomBenefitSelection below (reads the fetched price via a passed-in
// getter instead of a static table).
export const CUSTOM_BENEFIT_CATALOG = [
  {
    key: "diagnostic",
    name: "Diagnostic",
    description: "Lab tests and diagnostic screenings.",
    type: "wallet",
    icon:"/assets/images/plan-icons/diagnostic.png",
    bgImage: "/assets/images/custom-bg/diagnostics.png",
    bgColor: "#6E00B3",
    tiers: [
      { value: 5000, label: "₹5000", id: 947 },
      { value: 7500, label: "₹7500", id: 948 },
      { value: 10000, label: "₹10000", id: 949 },
    ],
  },
  {
    key: "pharmacy",
    name: "Pharmacy",
    description: "Prescribed medicines and pharmacy purchases.",
    type: "wallet",
    icon:"/assets/images/custom-bg/pharmacy-custom.svg",
    bgImage: "/assets/images/custom-bg/pharmacy-bg.png",
     bgColor: "#2e6f40",
    tiers: [
      { value: 5000, label: "₹5000", id: 158 },
      { value: 7500, label: "₹7500", id: 950 },
      { value: 10000, label: "₹10000", id: 951 },
    ],
  },
  {
    key: "tele-consultation",
    name: "Tele Consultation",
    description: "Video and phone consultations with doctors.",
    type: "credit",
    icon:"/assets/images/custom-bg/tele-custom.svg",
    bgImage: "/assets/images/custom-bg/teleconsultation-bg.png",
    bgColor:"#C22D2D",
    tiers: [
      { value: 5, label: "5 credits", id: 955 },
      { value: 10, label: "10 credits", id: 956 },
      { value: "unlimited", label: "Unlimited", id: 957 },
    ],
  },
  {
    key: "in-clinic-consultation",
    name: "In-Clinic Consultation",
    description: "In-person visits to network clinics.",
    type: "credit",
    icon:"/assets/images/plan-icons/building.png",
    bgImage: "/assets/images/custom-bg/inclinic-consultaion-bg.png",
    bgColor:"#BA8E23",
    tiers: [
      { value: 5, label: "5 credits", id: 952 },
      { value: 10, label: "10 credits", id: 953 },
      { value: "unlimited", label: "Unlimited", id: 954 },
    ],
  },
];


// `getPrice(benefitId)` resolves a tier's live price (from the bucket-model
// API cache - see useBucketPricing). Defaults to always-0 so callers that
// don't care about price (or haven't fetched yet) still get a valid shape.
export function buildCustomBenefitSelection(selections, getPrice = () => 0) {
  return CUSTOM_BENEFIT_CATALOG.filter((c) => selections[c.key] != null).map(
    (c) => {
      const tier = c.tiers[selections[c.key]];
      return {
        id: `custom-${c.key}-${tier.value}`,
        benefitId: tier.id,
        categoryKey: c.key,
        name: c.name,
        benefitAmount: c.type === "wallet" ? tier.value : 0,
        price: getPrice(tier.id) ?? 0,
        // "unlimited" is a string sentinel, not a number — kept as-is so the
        // UI can special-case it instead of it silently coercing to 0.
        creditAmount: c.type === "credit" ? tier.value : null,
        customType: c.type,
        customTierLabel: tier.label,
      };
    }
  );
}


